import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_PRE008_Request,
  IAPI_PRE008_Response,
  IAPI_APP013_Request,
  IAPI_APP013_Response,
} from "../../../type/apiType";

// 掛金納付対象職員届参照
const httpAPI_PRE008 = async (
  param: IAPI_PRE008_Request
): Promise<IAPI_PRE008_Response> => {
  let res = await http.post(ApiUrl.API_PRE008, {
    ...param,
  });
  return res.data;
};

// 掛金届の再提出
const httpAPI_APP013 = async (
  param: IAPI_APP013_Request
): Promise<IAPI_APP013_Response> => {
  let res = await http.post(ApiUrl.API_APP013, {
    ...param,
  });
  return res.data;
};

export { httpAPI_PRE008, httpAPI_APP013 };
